import React from 'react';
import language from '../language';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPaper, faFutbol } from '@fortawesome/free-solid-svg-icons';

const StartPage = ({ setSelectedSport }) => {
    return (
        <div className="start-page">
            <h1>{language.selectSport}</h1>
            <button onClick={() => setSelectedSport('handball')}>
                <FontAwesomeIcon icon={faHandPaper} /> {language.handball}
            </button>
            <button onClick={() => setSelectedSport('soccer')}>
                <FontAwesomeIcon icon={faFutbol} /> {language.soccer}
            </button>
        </div>
    );
};

export default StartPage;